





























































































































































































































import { Component, Vue } from "vue-property-decorator";
import { EventBus } from "../event-bus";
import { Account } from "../models/Account";
import { DeletedProfile } from "../models/DeletedProfile";
import { SystemConfig } from "../models/Config";
import { Token } from "../utils/Token";
import { Error } from "../utils/Error";
import {License} from "@/models/License";
import { UsbStatusModel } from "@/models/UsbStatus";
import axios from "axios";
import fileDownload from "js-file-download";
import CreateDevice from "@/components/CreateDevice.vue";
import DeletedProfilesModal from "@/components/DeletedProfilesModal.vue";
import EditDevice from "@/components/EditDevice.vue";
import ExpiringKeysModal from "@/components/ExpiringKeysModal.vue";
import ConfigModal from "@/components/ConfigModal.vue";
import UsbStatus from "../components/UsbStatus.vue";
import CreateFileUser from "@/components/CreateFileUser.vue" ;

@Component({
  components: {
    EditDevice,
    CreateDevice,
    DeletedProfilesModal,
    ExpiringKeysModal,
    ConfigModal,
    UsbStatus,
    CreateFileUser,
  },
  filters: {
    transformAccountStatus(value: number) {
      return value == 100 ? "Active" : "Disabled";
    },
    
    transformclientStatus(value: boolean) {
      return value ? "Ready" : "Pending";
    },
    transformFileSize(bytes:number){
      if (bytes == 0) { return "0.00 B"; }
      const e = Math.floor(Math.log(bytes) / Math.log(1024));
      return (bytes/Math.pow(1024, e)).toFixed(2)+' '+' KMGTP'.charAt(e)+'B';
    },
  },
})
export default class DeviceListing extends Vue {
[x: string]: unknown;
  public search = "";              

  public createDeviceModalFlag = false;
  public deletedProfilesModalFlag = false;
  public editDeviceModalFlag = false;
  public expiringKeysModalFlag = false;
  public configModalFlag = false;
  public usbStatusModalFlag=false;
  public createFileUserModalFlag=false;

  public usage = "";
  private systemConf:SystemConfig=new SystemConfig;
  public uStatus:UsbStatusModel=new UsbStatusModel;
  private licenseInfo: License=new License("",0);

  public users: Array<Account> = [];

  public headers = [
    {
      text: "First Name",
      align: "start",
      value: "firstName",
      sortable: true,
    },
    {
      text: "Last Name",
      value: "lastName",
      sortable: true,
      align: "start",
    },
    /* @MOFA: Uncomment this if we want the vpn stuff back.
    {
      text: "Status VPN",
      value: "statusVpn",
      sortable: true,
      align: "center",
    },
    */
    {
      text: "Account Status",
      value: "accountStatus",
      sortable: true,
      align: "center",
    },
    /* @MOFA: Uncomment this if we want the vpn stuf back.
    {
      text: "Last Time Connected",
      value: "connectedSince",
      sortable: true,
      align: "center",
    },
    {
      text: "Real Address",
      value: "realAddress",
      sortable: false,
      align: "center",
    },
    {
      text: "Bytes Sent",
      value: "bytesSent",
      sortable: true,
      align: "center",
    },
    */
    {
      text: "Keys state",
      value: "activeKeys",
      sortable: true,
      align: "center",
    },
    { 
      text: "Actions", 
      value: "actions", 
      sortable: false, 
      align: "center" 
    },
  ];


  created() {
    const memtoken = localStorage.getItem("token");
    if (!memtoken) {
      console.log("getTokenWithExpiry returns null when Generate new Token");
      this.$router.push({ name: "Login" });
      return null;
    }
    const atype = JSON.parse(memtoken).type;
    if(atype!=0){
      console.log("wrong user");
      this.$router.push({ name: "Files" });
    }else{

    const queue = Promise.resolve();
    const res=queue.then(()=>this.fetchUsers())
    .then(()=>this.ParseLicense())
    .then(()=>this.GetActiveMaxConnections())
    .catch((error) => {console.log(error)});

    EventBus.$off('closeCreateDeviceModal');
    EventBus.$off('closeCreateFileUserModal');
    EventBus.$off('closeEditDeviceModal');
    EventBus.$off('closeShowExpiringKeysModal');
    EventBus.$off('refreshListing');
    EventBus.$off('refreshUsage');
    EventBus.$off('refreshAccounts');
    EventBus.$off('openLicenseModal');
    EventBus.$off('openConfigModal');
    EventBus.$off('openShowExpiringKeysModal');
    EventBus.$off('openFileUserModal');
    EventBus.$off('closeLicenseModal');
    EventBus.$off('closeConfigModal');
    EventBus.$off('openDeletedProfilesModal');
    EventBus.$off('closeDeletedProfilesModal');
    EventBus.$off('recreateDevice');
    EventBus.$off('openRecreateDeviceModal');
  
    this.$store.dispatch('createSockets');
  

    EventBus.$on("closeCreateDeviceModal", (value: boolean) => {
      this.createDeviceModalFlag = value;
    });

    EventBus.$on("closeDeletedProfilesModal", (value: boolean) => {
      this.deletedProfilesModalFlag = value;
    });

    //Recreate on a deleted profile: open CreateDevice prefilled with its data
    EventBus.$on("recreateDevice", (profile: DeletedProfile) => {
      this.deletedProfilesModalFlag = false;
      EventBus.$emit("openRecreateDeviceModal", profile);
      this.createDeviceModalFlag = true;
    });

    EventBus.$on("closeCreateFileUserModal", (value: boolean) => {
      this.createFileUserModalFlag = value;
    });

    EventBus.$on("closeEditDeviceModal", (value: boolean) => {
      this.editDeviceModalFlag = value;
    });

    EventBus.$on("closeShowExpiringKeysModal", (value: boolean) => {
      this.expiringKeysModalFlag = value;
    });

    EventBus.$on("closeConfigModal", (value: boolean) => {
      this.configModalFlag = value;
      
    });

    EventBus.$on("refreshUsbStatus", (value: UsbStatusModel) => {
      this.uStatus=value;
    });

    EventBus.$on("changeUsbStatusModal", (value: boolean,status: UsbStatusModel) => {
      this.uStatus=status;
      this.usbStatusModalFlag = value;
    });

    EventBus.$on("refreshListing", () => {
      this.fetchUsers();
    });

    //when usage socket receives message, emits to this event to refresh usage
    EventBus.$on("refreshUsage", (value: string,systemConf:SystemConfig) => {
      this.usage = value;
      this.systemConf=systemConf;
    });

    //when accounts socket receives message, emits to this event to refresh users table
    EventBus.$on("refreshAccounts", (value: Array<Account>) => {
      this.users = value;
    })

    ////////EventBus.$emit("FinishLoader",null );   

    }
  }

  
  async downloadApk(extension: number, filename: string) {
    const token = await Token.getTokenWithExpiry("token");
    //////////EventBus.$emit("BeginLoader",null );   

    axios({
      method: "get",
      responseType: "blob",
      withCredentials: true,
      url: `${process.env.VUE_APP_APK_URL}/${extension}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        //////EventBus.$emit("FinishLoader",null );
        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          console.log("response:", response);
          fileDownload(response.data, filename);
        }
      })
      .catch((err) => {
        //////EventBus.$emit("FinishLoader",null );
        console.log("error:", err);
      });
  }

  async downloadLinphone(extension: number, filename: string) {
    const token = await Token.getTokenWithExpiry("token");
    //////EventBus.$emit("BeginLoader",null );   

    axios({
      method: "get",
      responseType: "blob",
      withCredentials: true,
      url: `${process.env.VUE_APP_SIP_URL}/${extension}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        ////EventBus.$emit("FinishLoader",null );
        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          console.log("response:", response);
          fileDownload(response.data, filename);
        }
      })
      .catch((err) => {
        //////EventBus.$emit("FinishLoader",null );
        console.log("error:", err);
      });
  }

  private async fetchUsers() {
    console.log("Fetching Users");
    
    const token = await Token.getTokenWithExpiry("token");
    console.log("token:", token);
    ////////EventBus.$emit("BeginLoader",null );   

    await axios({
      method: "get",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/devices`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        ////EventBus.$emit("FinishLoader",null );
        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          console.log("response:", response);
          if (response.data.code == 200) {
            this.users = [];

            response.data.results.forEach((user: Account) => {
              user = new Account(
                user.firstName,
                user.lastName,
                user.extension,
                user.statusVpn,
                user.statusSip,
                user.clientStatus,
                user.linphoneStatus,
                user.accountStatus,
                user.accountId,
                user.description,
                user.realAddress,
                user.bytesSent,
                user.connectedSince,
                user.ipv4Address,
                user.netMask,
                user.gateway,
                user.email,
                user.location,
                user.activeKeys,
                user.altIpv4Address,
                user.altNetMask,
                user.altGateway,
              );

              this.users.push(user);
            });
          }
        }
      })
      .catch((err) => {
        //////EventBus.$emit("FinishLoader",null );
        Error.handleError(err);
      });
  }

  public showCreateDeviceModal() {
    this.createDeviceModalFlag = true;
  }

  public showDeletedProfilesModal() {
    EventBus.$emit("openDeletedProfilesModal", this.users);
    this.deletedProfilesModalFlag = true;
  }

  public showCreateFileUserModal(mode:boolean) {
    EventBus.$emit("openFileUserModal",mode);
    this.createFileUserModalFlag = true;
  }
  
  public showFileExplorerModal() {
    this.$router.push({ name: "Files" });
  }

  public showExpiringKeysModal(){
    EventBus.$emit("openShowExpiringKeysModal", this.users);
    this.expiringKeysModalFlag=true;
  }

  public showConfigModal(){
    EventBus.$emit("openConfigModal", this.systemConf,this.licenseInfo);
    this.configModalFlag=true;
  }

  public checkRemainingKeys(value: number) {
      return value<this.$store.state.limit;
  }

  public async editUser(user: number, obj: Account) {
    console.log(user);
    const token = await Token.getTokenWithExpiry("token");
    ////////EventBus.$emit("BeginLoader",null );   

    await axios({
      method: "get",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/device/${user}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        //////EventBus.$emit("FinishLoader",null );
        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          console.log("response:", response);
          if (response.data.code == 200) {
            this.users = [];

            response.data.results.forEach((user: Account) => {
              user = new Account(
                obj.firstName,
                obj.lastName,
                obj.extension,
                obj.statusVpn,
                obj.statusSip,
                obj.clientStatus,
                obj.linphoneStatus,
                obj.accountStatus,
                obj.accountId,
                obj.description,
                obj.realAddress,
                obj.bytesSent,
                obj.connectedSince,
                user.ipv4Address,
                user.netMask,
                user.gateway,
                obj.email,
                obj.location,
                obj.activeKeys,
                user.altIpv4Address,
                user.altNetMask,
                user.altGateway,
              );
              console.log("user ",user)
              console.log("obj ",obj)

              EventBus.$emit("openEditDeviceModal", user);
              this.editDeviceModalFlag = true;
            });
          }
        }
      })
      .catch((err) => {
        //////EventBus.$emit("FinishLoader",null );
        Error.handleError(err);
      });
    // EventBus.$emit("openEditAccountModal", user);
  }

//PUT("/api/license)
  public async ParseLicense(){
    const token = await Token.getTokenWithExpiry("token");
    await axios({
      method: "post",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/license`,
      //because we dont want to update the license just to fetch data
      data:{name:""},
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          if (response.data.code == 200) {
            const items = response.data;
            //console.log("claims",items);
            //first get data and put them in license info and then broadcast the version
            this.licenseInfo=new License(items.version,items.numOfClients, items.deviceslicense);
            this.$store.dispatch('updateVersion', this.licenseInfo.Version);

        }}})
      .catch((err) => {
        console.log("error:", err);
        //////EventBus.$emit("FinishLoader",null );   
        return false;
      });
      
        return false;
  }
 

  private async GetActiveMaxConnections(){
    const token = await Token.getTokenWithExpiry("token");
    axios({
      method: "get",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/activeAndMaxConnections`,
      //because we dont want to update the license just to fetch data
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          if (response.data.code == 200) {
                  this.usage = response.data.activeConnections+"/"+ response.data.maxConnections;

        }}})
      .catch((err) => {
        console.log("error:", err);
        //////EventBus.$emit("FinishLoader",null );   
        return false;
      });
      
        return false;
      }
 
}

